import o from"react";const a=o.memo(({anchorKey:e,type:t})=>o.createElement("div",{key:e,type:t,"data-hook":e}));export{a as default};
//# sourceMappingURL=Anchor.js.map
